import {
  graphqlCall,
  listVideoContent,
  ListVideoContentQuery,
} from '@akin-home/amplify';
import { VideoTutorialData } from '@akin-home/video-tutorials';

export const listTutorialVideosQuery = async () => {
  const res = await graphqlCall<ListVideoContentQuery>(listVideoContent);

  if (!res.data.listVideoContent) {
    return [];
  }

  return JSON.parse(res.data.listVideoContent).body as VideoTutorialData[];
};
